import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './WetAreasComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';

function WetAreasComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('WetAreasComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const getVisibilityBasedOnSwim = () => {
        if (!_.isUndefined(modelVM.value.numofSwiPooIndFie) && modelVM.value.numofSwiPooIndFie > 0) {
            return true
        }

        if (!_.isUndefined(modelVM.value.numofSwiPooOutFie) && modelVM.value.numofSwiPooOutFie > 0) {
            return true
        }

        return false
    }

    const getVisibilityBasedOnWhirlAndHotTub = () => {
        if (!_.isUndefined(modelVM.value.numofWhiFie) && modelVM.value.numofWhiFie > 0) {
            return true
        }

        if (!_.isUndefined(modelVM.value.numofHottubFie) && modelVM.value.numofHottubFie > 0) {
            return true
        }

        return false
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        typofSauFie: {
            visible: !_.isUndefined(modelVM.value.numofsauonpreFie) && modelVM.value.numofsauonpreFie > 0
        },
        gooRepFie: {
            visible: !_.isUndefined(modelVM.value.numofsauonpreFie) && modelVM.value.numofsauonpreFie > 0,
            defaultValue: true
        },
        scoonanywalFie: {
            visible: !_.isUndefined(modelVM.value.numofsauonpreFie) && modelVM.value.numofsauonpreFie > 0,
            defaultValue: false
        },
        heaEleatl4froCloWaWalFie: {
            visible: !_.isUndefined(modelVM.value.numofsauonpreFie) && modelVM.value.numofsauonpreFie > 0
        },
        firBarbetHeaUniandWalFie: {
            visible: !_.isUndefined(modelVM.value.numofsauonpreFie) && modelVM.value.numofsauonpreFie > 0
        },
        anypoousefortraFie: {
            visible: getVisibilityBasedOnSwim()
        },
        nonSliDecFie: {
            visible: getVisibilityBasedOnSwim()
        },
        maxDepftFie: {
            visible: getVisibilityBasedOnSwim()
        },
        divBoaFie: {
            visible: getVisibilityBasedOnSwim()
        },
        sliFie: {
            visible: getVisibilityBasedOnSwim()
        },
        numofsliindFie: {
            visible: !_.isUndefined(modelVM.value.sliFie) && modelVM.value.sliFie
        },
        numofslioutFie: {
            visible: !_.isUndefined(modelVM.value.sliFie) && modelVM.value.sliFie
        },
        supFie: {
            visible: getVisibilityBasedOnSwim()
        },
        proSigPosFie: {
            visible: getVisibilityBasedOnSwim()
        },
        swiatyouOwnRisSigPPosFie: {
            visible: getVisibilityBasedOnSwim()
        },
        lesGivFie: {
            visible: getVisibilityBasedOnSwim()
        },
        cheTesDaiFie: {
            visible: getVisibilityBasedOnSwim()
        },
        proMaiLogRecFie: {
            visible: getVisibilityBasedOnSwim()
        },
        nonslimatFie: {
            visible: getVisibilityBasedOnWhirlAndHotTub()
        },
        proraiFie: {
            visible: getVisibilityBasedOnWhirlAndHotTub()
        },
        ovedraFie: {
            visible: getVisibilityBasedOnWhirlAndHotTub()
        },
        numofShoFie: {
            visible: getVisibilityBasedOnWhirlAndHotTub()
        },
        istheShoSurNonSliishoFie: {
            visible: !_.isUndefined(modelVM.value.numofShoFie) && modelVM.value.numofShoFie > 0,
            defaultValue: true
        },
        istheShoSurNonSlioshoFie: {
            visible: !_.isUndefined(modelVM.value.numofShoFie) && modelVM.value.numofShoFie > 0,
            defaultValue: true
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

WetAreasComponent.propTypes = wizardProps;
export default withRouter(WetAreasComponent);
